export const paramsStringToMapping = (params: string): Record<string, any> => {
  const record: Record<string, any> = {};
  for (const [key, value] of new URLSearchParams(params).entries()) {
    record[key] = value;
  }
  return record;
};
